import { Route, UrlMatcher } from '@angular/router';
import { CollectionFlowComponent } from './collection-flow/collection-flow.component';
import { CollectionRevisionFileEditorController } from './collection-flow/collection-revision-file-editor.controller';
import { CollectionRevisionLifecycleCoordinator } from './collection-flow/collection-revision-lifecycle-coordinator';
import { collectionLanguageGuard } from './guards/collection-language.guard';
import { collectionDirtyNavigationGuard } from './guards/collection-dirty-navigation.guard';

export const collectionFlowMatcher: UrlMatcher = (segments) => {
  const hasPlainIdentity = (index: number) =>
    (segments[index]?.path.trim().length ?? 0) > 0;

  if (
    segments.length === 2 &&
    segments[0].path === 'collection' &&
    hasPlainIdentity(1)
  ) {
    const posParams = { collectionId: segments[1] } satisfies Record<
      string,
      (typeof segments)[number]
    >;
    return {
      consumed: segments,
      posParams,
    };
  }

  if (
    segments.length === 6 &&
    segments[0].path === 'collection' &&
    hasPlainIdentity(1) &&
    segments[2].path === 'revisions' &&
    hasPlainIdentity(3) &&
    segments[4].path === 'targets' &&
    hasPlainIdentity(5)
  ) {
    const posParams = {
      collectionId: segments[1],
      revisionId: segments[3],
      targetId: segments[5],
    } satisfies Record<string, (typeof segments)[number]>;
    return {
      consumed: segments,
      posParams,
    };
  }

  return null;
};

export const collectionFlowRoutes: Route[] = [
  {
    matcher: collectionFlowMatcher,
    component: CollectionFlowComponent,
    canActivate: [collectionLanguageGuard],
    canDeactivate: [collectionDirtyNavigationGuard],
    providers: [
      CollectionRevisionFileEditorController,
      CollectionRevisionLifecycleCoordinator,
    ],
    title: 'MZIC Collection Flow',
  },
];
